/**
 * 渠道包上传弹窗组件
 */
import React from 'react'
import { logger } from 'utils/logger'
import { StoreProvider } from './store'
import reducer from './reducer'
import { initialState } from './initialState'
import Dialog from '@tencent/spaui-dialog'
import UploadSetting from 'biz-components/UploadSetting'
import UploadConfirm from 'biz-components/UploadConfirm'
import UploadResults from 'biz-components/UploadResults'
import { genTitle } from './utils'
import useUploadChannelPkg from './hooks/useUploadChannelPkg'

const UploadDialog = props => {
    const { className, inlineStyle, dialogType } = props
    const { handleSubmit, step, reset, disableSubmit } = useUploadChannelPkg(props)
    const onCancelClick = () => {
        logger.info(`uploadDialog close: step = ${step}`)
        props.onClose && props.onClose()
        reset()
    }
    return (
        <Dialog
            className={`track-dialog ${className || ''}`}
            onSubmit={handleSubmit}
            title={genTitle(dialogType, step)}
            style={{
                width: step === 3 ? '880px' : '500px',
                ...inlineStyle,
            }}
            type="normal"
            submitLabel={disableSubmit ? '提交中...' : '确定'}
            disabled={disableSubmit}
            backdrop
            {...props}
            onClose={onCancelClick}
            onCancel={onCancelClick}
        >
            {(() => {
                switch (step) {
                    case 1:
                        return <UploadSetting {...props} onCancel={onCancelClick} />
                    case 2:
                        return <UploadConfirm {...props} />
                    case 3:
                        return <UploadResults {...props} />
                    default:
                        return ''
                }
            })()}
        </Dialog>
    )
}

const UploadChannelPkg = props => {
    return (
        <StoreProvider initialState={initialState} reducer={reducer}>
            <UploadDialog {...props} />
        </StoreProvider>
    )
}

export default UploadChannelPkg
